import React, { useState, useEffect } from "react";
import {
  validateOnlyNumbers,
  validateOnlyAlphanumeric,
  validateOnlyLetters,
} from "../Utils/validators";
import { relations } from "../Utils/constants";

function beneficiaryForm({
  beneficiary,
  index,
  updateBeneficiary,
  removeBeneficiary,
  count,
  existsErrors,
}) {
  const [data, setData] = useState(beneficiary);
  const [errors, setErrors] = useState({
    documento: existsErrors,
    relacion: existsErrors,
    porcentaje: existsErrors,
    nombres: existsErrors,
    apePaterno: existsErrors,
    apeMaterno: existsErrors,
  });

  useEffect(() => {
    setData(beneficiary);
  }, [beneficiary]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    const clon = { ...data };
    if (name === "porcentaje") {
      if (value === "" || !validateOnlyNumbers(newValue)) {
        newValue = "";
      } else {
        if (parseFloat(value) < 1 || parseFloat(newValue) > 100) {
          newValue = "";
        }
      }
    } else if (name === "documento") {
      if (newValue !== "" && !validateOnlyAlphanumeric(newValue)) {
        newValue = data[name];
      }
    } else if (
      name === "nombres" ||
      name === "apePaterno" ||
      name === "apeMaterno"
    ) {
      if (newValue !== "" && !validateOnlyLetters(newValue)) {
        newValue = data[name];
      }
    }

    clon[name] = newValue;
    setData(clon);
    validate(name, newValue);

    let errorValidation = false;
    Object.entries(errors).some((item) => {
      if (item[1]) {
        errorValidation = true;
        return true;
      }
    });

    updateBeneficiary(clon, index, errorValidation);
  };

  const validate = (name, value) => {
    let valid = true;
    switch (name) {
      case "documento":
        if (value.toString().length < 8) {
          valid = false;
        }
        break;
      case "porcentaje":
        if (isNaN(value) || value.toString().length < 1) {
          valid = false;
        } else {
          if (parseFloat(value) <= 0 || parseFloat(value) > 100) {
            valid = false;
          }
        }
        break;
      case "nombres":
      case "apePaterno":
      case "relacion":
        if (value.toString().length < 2) {
          valid = false;
        }
        break;
    }
    errors[name] = !valid;
    setErrors(errors);
  };

  const remove = (e) => {
    e.preventDefault();
    removeBeneficiary(index);
  };

  return (
    <div className={`beneficiaryForm${index === 0 ? " first" : ""}`}>
      {count > 1 && (
        <a href="#" className="remove" onClick={(e) => remove(e)}></a>
      )}
      <div className="beneficiaryForm__group">
        <div className="beneficiaryForm__group__item documentType">
          <select
            className=""
            name="tipoDoc"
            value={data.tipoDoc}
            onChange={(e) => handleChange(e)}
          >
            <option default value="2">
              DNI
            </option>
            <option value="1">CARNET EXTRANJERIA</option>
          </select>
        </div>
        <div className="beneficiaryForm__group__item document input-field">
          <input
            type="text"
            className={errors.documento ? "error" : ""}
            autoComplete="off"
            id={`documento_${index}`}
            name="documento"
            value={data.documento}
            onChange={(e) => handleChange(e)}
            maxLength="15"
          />
          <label
            className={data.documento ? "active" : ""}
            htmlFor={`documento_${index}`}
          >
            Nro Documento
          </label>
        </div>
        <div className="beneficiaryForm__group__item relation">
          <select
            className={errors.relacion ? "error" : ""}
            name="relacion"
            value={data.relacion}
            onChange={(e) => handleChange(e)}
          >
            <option value="">Relación</option>
            {relations.map((e, i) => (
              <option key={i} value={e.description}>
                {e.description}
              </option>
            ))}
          </select>
        </div>
        <div className="beneficiaryForm__group__item percentage input-field">
          <input
            type="text"
            className={errors.porcentaje ? "error" : ""}
            autoComplete="off"
            id={`porcentaje_${index}`}
            name="porcentaje"
            value={data.porcentaje}
            onChange={(e) => handleChange(e)}
            pattern="[0-9]*"
            inputmode="numeric"
          />
          <label
            className={data.porcentaje ? "active" : ""}
            htmlFor={`porcentaje_${index}`}
          >
            Porc. %
          </label>
        </div>
      </div>
      <div className="beneficiaryForm__group">
        <div className="beneficiaryForm__group__item textName input-field">
          <input
            type="text"
            className={errors.nombres ? "error" : ""}
            autoComplete="off"
            id={`nombres_${index}`}
            name="nombres"
            value={data.nombres}
            onChange={(e) => handleChange(e)}
            maxLength="30"
          />
          <label
            className={data.nombres ? "active" : ""}
            htmlFor={`nombres_${index}`}
          >
            Nombres
          </label>
        </div>
        <div className="beneficiaryForm__group__item textName input-field">
          <input
            type="text"
            className={errors.apePaterno ? "error" : ""}
            autoComplete="off"
            id={`apePaterno_${index}`}
            name="apePaterno"
            value={data.apePaterno}
            onChange={(e) => handleChange(e)}
            maxLength="30"
          />
          <label
            className={data.apePaterno ? "active" : ""}
            htmlFor={`apePaterno_${index}`}
          >
            Apellido Paterno
          </label>
        </div>
        <div className="beneficiaryForm__group__item textName input-field">
          <input
            type="text"
            className={errors.apeMaterno ? "error" : ""}
            autoComplete="off"
            id={`apeMaterno_${index}`}
            name="apeMaterno"
            value={data.apeMaterno}
            onChange={(e) => handleChange(e)}
            maxLength="30"
          />
          <label
            className={data.apeMaterno ? "active" : ""}
            htmlFor={`apeMaterno_${index}`}
          >
            Apellido Materno
          </label>
        </div>
      </div>
    </div>
  );
}
export default beneficiaryForm;
